import React, { FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import RollAccessKey from "../../common/RollAccessKey/RollAccessKey";
import { Link } from "react-router-dom";
import AmpButton from "../../common/AmpButton/AmpButton";
import { loginRegisterRoll } from "../../../redux/actions/auth/auth";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import { RootState } from "../../../redux/reducers/root";
import { RollLoginState } from "../../../redux/reducers/getAuthReducer/rollLoginReducer";

import AmpCaptcha from "../../common/AmpCaptcha/AmpCaptcha";
import AmpInlineLoadingSpinner from "../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner";
import ReactGA from "react-ga4";

export default function NewUserForm(): JSX.Element {

    const { t } = useTranslation('login');
    const dispatch = useDispatch();
    const [captchaKey, setCaptchaKey] = useState(1);

    const rollloginResult = useSelector((state: RootState) => state.authReducer.rollLogin as RollLoginState);
    
    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        const data: FormData = new FormData(e.target as HTMLFormElement);
        const values = Object.fromEntries(data.entries()) as Record<string, string>;

        const rollParts = Object.keys(values)
            .filter((key) => key.includes("roll_part"))
            .reduce((cur, key) => { return Object.assign(cur, { [key]: values[key] }) }, {});

        let rollNumber = "";
        Object.keys(rollParts).forEach(
            (value) => {
                rollNumber += values[value];
            }
        )

        const testPayload = {
            "rollNumber": rollNumber,
            "accessKey": values["access-key"],
            "g-recaptcha-response": values["g-recaptcha-response"]
        }
        setCaptchaKey(captchaKey + 1);
        ReactGA.event({
            category: "Login/Registration",
            action: "Registration Form Submitted",
            label: `${rollNumber} Registration`, // optional
        });

        //@ts-ignore
        if(window.lintrk) {
            //@ts-ignore
            window.lintrk('track', { conversion_id: 18150428 });
        }
        //@ts-ignore
        if(window.fbq) {
            //@ts-ignore
            window.fbq('track', 'CompleteRegistration');
        }

        dispatch(loginRegisterRoll(testPayload));
    }

    const isError = rollloginResult.success === false && !rollloginResult.loading;
    const isShared = isError && rollloginResult.shared;
    const isCaptchaFailed = !rollloginResult.captcha;
    const noData = rollloginResult.message === "Roll Number Not Found"
    const message = noData ? t("no-data") : isShared ? t('new-user-shared') : (isCaptchaFailed ? t("verify-captcha") : (isError ? t("new-user-error") : ""));


    const [resetting, setReset] = useState(false);

    useEffect(() => {
        if (resetting) {
            setTimeout(() => {
                setReset(false);
            }, 400);
        }
    }, [resetting])

    const reset = () => {
        setReset(true)
    }

    return (
        <>
            {resetting &&
                <div className="refreshing refreshing-small">
                    <AmpInlineLoadingSpinner />
                </div>
            }
            {!resetting && (
                <form onSubmit={(e) => { onSubmit(e) }}>
                    <div className="login-container-mid">
                        <RollAccessKey />
                        <AmpCaptcha key={captchaKey} />
                    </div>
                    <AmpFormError error={isError} errorMessage={message} />
                    <div className="login-container-footer">
                        <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
                        <div>
                            <AmpButton buttonType="reset" type="cancel" onClick={() => reset()} text={t("cancel")} />
                            <AmpButton buttonType="submit" type="submit" onClick={() => null} text={t("register")} />
                        </div>
                    </div>
                </form>
            )}
        </>
    )
}

